"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitch = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Bubble_1 = require("../../../../Bubble");
var alignPoints = [{ align: "cr cl" }];
exports.ToggleSwitch = function (props) {
    var id = props.id, label = props.label, checked = props.checked, questionMarkMessage = props.questionMarkMessage, className = props.className, onChange = props.onChange;
    var css = classnames_1.default("toggle-wrapper-revers-label", className);
    return (react_1.default.createElement("div", { className: css },
        react_1.default.createElement("label", { className: "input-checkbox-toggle s-checkbox-toggle-label" },
            react_1.default.createElement("input", { type: "checkbox", className: className, id: id, name: id, checked: checked, onChange: onChange }),
            react_1.default.createElement("span", { className: "input-label-text toggle-switch" })),
        react_1.default.createElement("label", { className: "toggle-switch-title", htmlFor: label }, label),
        questionMarkMessage ? (react_1.default.createElement(Bubble_1.BubbleHoverTrigger, null,
            react_1.default.createElement("span", { className: "gd-icon-circle-question s-circle_question toggle-switch-icon" }),
            react_1.default.createElement(Bubble_1.Bubble, { alignPoints: alignPoints }, questionMarkMessage))) : null));
};
//# sourceMappingURL=ToggleSwitch.js.map